import { HorizontalFlex } from '@eversports/react-components/primitives/Flex'
import Icon from '@eversports/react-components/primitives/Icon'
import SpotIcon from '@eversports/react-components/primitives/Icon/custom-icons/Spot'
import Text from '@eversports/react-components/primitives/Text'
import Link from '@eversports/klimt-primitives/legacy/Link'
import { useLocation } from 'react-router-dom'
import { Localized } from '../../../localization/react'
import { AssignedSpot } from '../../../typings/BookableItem'
import useConfirmationActions from '../../../data/useConfirmationActions'
import { SPOT_BOOKING_FROM } from '../../Confirmation/Confirmation.constants'
import getPhoenixUrlParams from '../../../lib/get-phoenix-url-params'
import { Origin } from '../../../graphql'

interface Props {
  assignedSpot?: AssignedSpot
}

function BookingDetailsAssignedSpot({ assignedSpot }: Props) {
  const { goToModifySpots } = useConfirmationActions()

  const location = useLocation()
  const { origin } = getPhoenixUrlParams(location.search)
  const isWidget = [Origin.ORIGIN_WIDGET, Origin.ORIGIN_PROVIDER_API].includes(origin)

  if (!goToModifySpots) {
    return null
  }

  return (
    <Link to={isWidget ? goToModifySpots : `${goToModifySpots}?from=${SPOT_BOOKING_FROM.YOUR_SPOT_LINK}`} external>
      <HorizontalFlex horizontalSpacing="dense" alignItems="center">
        <Icon icon={SpotIcon} color="subtleText" />
        <Text fontWeight="bold" size="small" style={{ textDecoration: 'underline' }}>
          {assignedSpot ? (
            <>
              <Localized id="booking-details-assigned-spot" /> {assignedSpot.label}
            </>
          ) : (
            <Localized id="booking-details-assigned-spot-missing" />
          )}
        </Text>
      </HorizontalFlex>
    </Link>
  )
}
export { BookingDetailsAssignedSpot }
